module.exports = "const itemsArray = [...] // This is our data\n\nfunction rowRenderer ({ index }) {\n  return (\n    <div key={index}>\n      {itemsArray[index].name}\n    </div>\n  )\n}\n\nfunction renderList () {\n  return (\n    <div\n      style={{\n        height: 240,\n        width: 240\n      }}\n    >\n      {itemsArray.map((item, index) => rowRenderer({ index }))}\n    </div>\n  )\n}\n"


/*****************
 ** WEBPACK FOOTER
 ** ./~/raw-loader!./examples/perf-comparison-non-virtualized.js
 ** module id = 375
 ** module chunks = 0
 **/